import React, { useEffect, useState } from 'react'
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { IndeterminateCheckbox, licenseOptionMap } from 'components/tables/tableTools'
import ZeusTable2 from 'components/tables/ZeusTable2.tsx'

import { createColumnHelper } from '@tanstack/react-table'

export default function LicenseDetails(props) {

    const API = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        withCredentials: true,
    });

    // Table data
    const [data, setData] = useState({})
    const [initialSelection, setInitialSelection] = useState([])
    const [currentSelection, setCurrentSelection] = useState([])
    const [license, setLicense] = useState(115)

    const allOptions = [...licenseOptionMap];

    async function getOptions() {
        try {
            const selectedOptions = await API.post("/get-license-options", { 'licenseId': license });
            setData(allOptions);
            //setCurrentSelection(selectedOptions.data)
            const usersOptions = selectedOptions.data.map(o => o.name)

            const tableRowSelections = allOptions.reduce((acc, item, index) => {
                if (usersOptions.includes(item.name)) {
                    acc[index] = true;
                }
                return acc;
            }, {});

            setInitialSelection(tableRowSelections)
            setCurrentSelection(tableRowSelections)
        } catch (error) {
            console.log(error?.response?.data);
            toast.error(error?.response?.data)
        }
    }
    useEffect(() => {
        getOptions();
        console.log(props)
    }, [])

    // Table construction
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'Selection',
            header: () => <span>Selected</span>,
            cell: ({ row }) => <IndeterminateCheckbox
                {...{
                    checked: row.getIsSelected(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }}
            />,
        }),
        columnHelper.accessor(row => row.alias, {
            id: 'License Option',
            header: () => <span>License Option</span>,
            cell: info => info.getValue(),
            footer: info => info.column.id,
        })
    ]

    useEffect(() => {
        const unitSelection = []
        for (let i = 0; i < Object.keys(data).length; i++) {
            if (currentSelection[i] === true) {
                unitSelection.push(data[i].unit_id)
            }
        }
        //setUnits(unitSelection)
    }, [currentSelection])

    const closeForm = () => {
        toast.error("Selection changes discarded")
        props.closeForm()
    }

    const saveChanges = () => {
        console.log("Saving data", currentSelection)
        const addedIndices = Object.keys(currentSelection)
            .filter(key => currentSelection[key] && !initialSelection[key]);
        
        const removedIndices = Object.keys(initialSelection)
            .filter(key => initialSelection[key] && !currentSelection[key]);

        const addedNames = addedIndices.map(i => allOptions[i].name);
        const removedNames = removedIndices.map(i => allOptions[i].name);

        console.log("Added:", addedNames);
        console.log("Removed:", removedNames);
        // Remove and create options in database

    }

    return (
        <div>
            <div id="Unis" className={`modal fade ${true ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ paddingRight: 5 + 'px' }} aria-modal="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button  onClick={() => closeForm()} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title" data-locale="Units">Units</h4>
                        </div>
                        <div className="modal-body">

                            <ZeusTable2
                                columns={columns}
                                data={data}
                                rowSelection={currentSelection}
                                setRowSelection={setCurrentSelection}
                                refreshData={getOptions}
                                pageSize='30'
                            />

                        </div>
                        <div className="form-group row">
                                <div className="col-sm-10" style={{textAlign: 'right'}}>
                                    <button onClick={() => closeForm()} type="button" className="btn btn-default" data-dismiss="modal" data-locale="close">
                                        Close
                                    </button>
                                    <button onClick={() => saveChanges()} type="button" className="btn btn-primary save" data-locale="save">
                                        Save
                                    </button>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}